import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Collaboration } from '../../interfaces/collaboration.interface';

@Injectable()
export class CollaborationService {

    private url = `${environment.api}/collaboration/`;
    constructor(private http: HttpClient) { }

    save(collaboration: Collaboration): Observable<any> {
        return this.http.post<any>(`${this.url}`, collaboration);
    }

    update(collaboration: Collaboration): Observable<any> {
        return this.http.put<any>(`${this.url}`, collaboration);
    }

    delete(primaryKey: any): Observable<any> {
        return this.http.delete<any>(`${this.url}/${primaryKey}`, );
    }

    query(queryParameter: any): Observable<any[]> {
        return this.http.get<any[]>(`${environment.api}/collaboration/query/${encodeURI(JSON.stringify(queryParameter))}`);
    }

    aggregate(param: any): Observable<any[]> {
        return this.http.get<any[]>(`${environment.api}/collaboration/aggregate/${encodeURI(JSON.stringify(param))}`);
    }
    // Trouve un seul enregistrements de TypeEntity
    findOne(primaryKey: any): Observable<any> {
        return this.http.get<any>(`${environment.api}/collaboration/${encodeURI(JSON.stringify(primaryKey))}`);
    }
}
